import React, {useEffect, useState} from 'react';
import {Link, Outlet, useNavigate} from 'react-router-dom';
import {Burger, ExitBurger, Logo} from '../../ui/icons';
import {FaWhatsapp, FaTelegram, FaInstagram, FaFacebook, FaYoutube} from "react-icons/fa";
import {useDispatch, useSelector} from "react-redux";
import useWindowWidth from "../../ui/hooks/useWindowWidth";
import {getUser} from "../../store/authSlice";

const Layout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {token} = useSelector(state => state.auth);
    const {token: registerToken} = useSelector(state => state.form);
    const [active, setActive] = useState("/");
    const [menuOpen, setMenuOpen] = useState(false)
    const links = ["Main", "About the course", "Certification", "About OAA", "OAA Community"];
    const width = useWindowWidth()
    const {user} = useSelector((store) => store.auth)
    const handleLogout = () => {
        navigate("/profile");
    };
    useEffect(() => {
        dispatch(getUser())
    }, [])
    return (
        <>
            <header className="px-[20px] sm:px-[50px] py-[14px] sm:py-[17px]">
                <nav className="flex justify-between items-center relative  bg-white">
                    <div className='flex items-center'>
                        <div className="flex items-center ">

                            <Link to='/'>
                                <Logo/>
                            </Link>

                        </div>

                        <ul
                            className={`xl:ml-[100px] fixed top-0 left-0 sm:wleft-[120px] w-full h-[80vh] md:h-auto bg-[rgba(10,31,68,0.81)] z-50 p-6 shadow-md transform transition-transform ${menuOpen ? "translate-x-0" : "-translate-x-full"
                            } md:translate-x-0 md:relative md:p-0 md:shadow-none md:flex md:items-center md:space-x-6 md:bg-transparent`}
                        >
                            {/* Крестик справа */}
                            <button
                                className="absolute top-4 right-6 text-white text-3xl md:hidden"
                                onClick={() => setMenuOpen(false)}
                            >
                                <ExitBurger/>
                            </button>

                            {/* Контейнер списка */}
                            <div
                                className="flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-6 pt-[70px] md:pt-0 ml-[30px]">
                                {links.map((link, idx) => {
                                    const formattedLink =
                                        link === "Main" ? "/" : `/${link.trim().toLowerCase().replace(/\s+/g, "")}`;
                                    return (
                                        <li key={link} className="md:inline-block block py-2">
                                            {
                                                links.length - 1 === idx ?
                                                    <span
                                                        className={`link__header text-white md:text-gray-300 relative after:content-[''] after:absolute after:w-full after:h-[2px] after:bg-white md:after:gray after:left-0 after:bottom-[-2px] after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100 ${active === link ? "after:scale-x-100" : ""
                                                        }`}
                                                        title={"Coming Soon"}
                                                    >
                                                    {link}
                                                </span> : <Link
                                                        to={formattedLink}
                                                        className={`link__header text-white md:text-black relative after:content-[''] after:absolute after:w-full after:h-[2px] after:bg-white md:after:bg-black after:left-0 after:bottom-[-2px] after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100 ${active === link ? "after:scale-x-100" : ""
                                                        }`}
                                                        onClick={() => {
                                                            setActive(link.trim());
                                                            setMenuOpen(false);
                                                        }}
                                                    >
                                                        {link}
                                                    </Link>
                                            }

                                        </li>
                                    );
                                })}
                            </div>
                        </ul>


                    </div>
                    {
                        token || registerToken ? (
                            <div>

                                {
                                    width < 500 ?
                                        <div className='flex items-center gap-[18px ]'>
                                            <button onClick={handleLogout} className="text-black hover:underline">
                                                <svg width="40" height="41" viewBox="0 0 40 41" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="1" width="39" height="39" rx="19.5"
                                                          fill="#F8F8F8"/>
                                                    <rect x="0.5" y="1" width="39" height="39" rx="19.5"
                                                          stroke="#D7D7D7"/>
                                                    <path
                                                        d="M20 10.1C21.3261 10.1 22.5979 10.6268 23.5355 11.5645C24.4732 12.5021 25 13.7739 25 15.1C25 16.4261 24.4732 17.6979 23.5355 18.6355C22.5979 19.5732 21.3261 20.1 20 20.1C18.6739 20.1 17.4021 19.5732 16.4645 18.6355C15.5268 17.6979 15 16.4261 15 15.1C15 13.7739 15.5268 12.5021 16.4645 11.5645C17.4021 10.6268 18.6739 10.1 20 10.1ZM20 22.6C25.525 22.6 30 24.8375 30 27.6V30.1H10V27.6C10 24.8375 14.475 22.6 20 22.6Z"
                                                        fill="#D7D7D7"/>
                                                </svg>
                                            </button>
                                            <button className="ml-4 text-black text-xl md:hidden"
                                                    onClick={() => setMenuOpen(!menuOpen)}>
                                                <Burger/>
                                            </button>
                                        </div>
                                        :
                                        <div className='flex items-center gap-[30px] '>
                                            <Link to={"/passingcourse/1"}
                                                  className='bg-[#FFE6E6] p-[10px_14px] rounded-xl font-semibold hover:bg-[#FFe1e2]'>My
                                                course</Link>
                                            <button onClick={handleLogout}
                                                    className="text-black hover:underline flex items-center gap-[14px]">
                                                <svg width="40" height="41" viewBox="0 0 40 41" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="0.5" y="1" width="39" height="39" rx="19.5"
                                                          fill="#F8F8F8"/>
                                                    <rect x="0.5" y="1" width="39" height="39" rx="19.5"
                                                          stroke="#D7D7D7"/>
                                                    <path
                                                        d="M20 10.1C21.3261 10.1 22.5979 10.6268 23.5355 11.5645C24.4732 12.5021 25 13.7739 25 15.1C25 16.4261 24.4732 17.6979 23.5355 18.6355C22.5979 19.5732 21.3261 20.1 20 20.1C18.6739 20.1 17.4021 19.5732 16.4645 18.6355C15.5268 17.6979 15 16.4261 15 15.1C15 13.7739 15.5268 12.5021 16.4645 11.5645C17.4021 10.6268 18.6739 10.1 20 10.1ZM20 22.6C25.525 22.6 30 24.8375 30 27.6V30.1H10V27.6C10 24.8375 14.475 22.6 20 22.6Z"
                                                        fill="#D7D7D7"/>
                                                </svg>
                                                <p className='text-[16px] font-semibold'>
                                                    {user?.first_name} {user?.last_name}
                                                </p>
                                            </button>

                                        </div>
                                }
                            </div>
                        ) : (
                            <div className="flex items-center">
                                <Link to="/signin" className="text-black text-lg hover:underline">Login</Link>
                                <span className="mx-3">|</span>
                                <Link to="/signup" className="text-black text-lg hover:underline">Sign in</Link>
                                <button className="ml-4 text-black text-xl md:hidden"
                                        onClick={() => setMenuOpen(!menuOpen)}>
                                    <Burger/>
                                </button>
                            </div>
                        )
                    }


                </nav>
            </header>

            <Outlet/>

            <footer className="bg-[#8C1C1C] text-white py-12 px-[20px] sm:px-[50px]">

                <div className="max-w-[1024px]  grid grid-cols-1 sm:grid-cols-3 gap-8">

                    <div>
                        <h3 className="text-xl font-semibold mb-4">Pages</h3>
                        <ul className="space-y-2">
                            {links.map((page, index) => {
                                const formattedLink = page === "Main" ? "/" : `/${page.trim().toLowerCase().replace(/\s+/g, "")}`;
                                return (
                                    <li key={index} className="hover:text-[#c6a982] transition">
                                        {links.length - 1 !== index ? <Link to={formattedLink}>{page}</Link> : ''}
                                    </li>
                                )
                            })}
                            <li className="hover:text-[#c6a982] transition">
                                <Link to='/terms'>TERMS OF WEBSITE USE</Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold mb-4">Contacts</h3>
                        <div className="text-[#c6c0bb] text-sm">
                            <p className="mb-1">Phone number</p>
                            <a href="tel:+37493833238" className="text-white text-lg font-medium hover:underline">
                                +374 93 833238
                            </a>
                        </div>
                        <div className="text-[#c6c0bb] text-sm mt-4">
                            <p className="mb-1">E-mail</p>
                            <a href="mailto:info@oaacourses.com"
                               className="text-white text-lg font-medium hover:underline">
                                info@oaacourses.com
                            </a>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold mb-4">Social Media</h3>
                        <div className="space-y-2 flex flex-wrap items-end gap-5">
                            {[
                                {icon: <FaWhatsapp/>, name: "WhatsApp"},
                                {icon: <FaTelegram/>, name: "Telegram"},
                                {icon: <FaInstagram/>, name: "Instagram"},
                                {icon: <FaFacebook/>, name: "Facebook"},
                                {icon: <FaYoutube/>, name: "YouTube"}
                            ].map((social, index) => (
                                <div key={index}
                                     className="flex items-start justify-center gap-2 text-sm  hover:text-[#c6a982] transition cursor-pointer">
                                    <span className="text-2xl">{social.icon}</span>
                                    <span>{social.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
                <div className=''>

                </div>
            </footer>
        </>
    );
};

export default Layout;
